import Texts from "../texts";
import {TFunction} from "i18next";

class ApiResponseCodes {

    // ########################### HTTP SPECIFIC ###################################

    /**
     * When the given request is incomplete or wrong in the context of the server call
     */
    static readonly badRequest = 400;
    /**
     * When the user should log in to access the data from the server.
     */
    static readonly unauthorized = 401;
    /**
     * When the user does not have access to the requested data.
     */
    static readonly forbiddenAccess = 403;
    /**
     * When server was not found to communicate with
     */
    static readonly notFound = 404;
    /**
     * When server instance for the api call crashed or was terminated before any response could be given
     */
    static readonly serverError = 500;

    // ########################### CUSTOM ###################################

    /**
     * When the server call successfully was made but response was never returned.
     */
    static readonly aborted = 597;
    /**
     * When the server call failed due to a problem in request preparation.
     */
    static readonly requestFailed = 599;
    /**
     * When the server call successfully was made but response was never returned.
     */
    static readonly serverNotResponded = 598;
    /**
     * When the server call failed due to entity not found. (Internal status code)
     */
    static readonly internalNotFound = -404;
    /**
     * When the server call failed due to unauthorized access. (Internal status code)
     */
    static readonly internalUnauthorized = -401;
    /**
     * When the user does not have access to the requested data. (Internal status code)
     */
    static readonly internalAccessDenied = -403;


    /**
     * Fetches the default Text message from the code of the api call response.
     * @param t     Translation function
     * @param code  The code of the response.
     * @private
     */
    static getMessageFromCode(t: TFunction<"@bizkeytech">, code?: number): string | undefined {
        switch (code) {
            //    HTTP Codes
            case ApiResponseCodes.badRequest:
                return Texts.badRequest(t);
            case ApiResponseCodes.unauthorized:
                return Texts.unauthorized(t);
            case ApiResponseCodes.forbiddenAccess:
                return Texts.forbiddenAccess(t);
            case ApiResponseCodes.notFound:
                return Texts.notFound(t);
            case ApiResponseCodes.serverError:
                return Texts.serverError(t);

            //    Custom Codes
            case ApiResponseCodes.requestFailed:
                return Texts.requestFailed(t);
            case ApiResponseCodes.serverNotResponded:
                return Texts.requestFailed(t);
            case this.internalNotFound:
                return Texts.internalNotFound(t);
            case this.internalUnauthorized:
                return Texts.unauthorized(t);
            case this.internalAccessDenied:
                return Texts.forbiddenAccess(t);
            default:
                return;
        }
    }


}

export default ApiResponseCodes;
